import { useEffect, useState, type CSSProperties, type ReactNode } from 'react';
import { fetchImageUrl } from '../lib/api';

/**
 * Bild von einem geschützten API-Endpunkt.
 *
 * Lädt die Datei über den API-Client – mit Token im Header statt in der URL –
 * und gibt die Objekt-URL beim Verlassen wieder frei. Schlägt der Abruf fehl
 * oder ist kein Bild hinterlegt, erscheint der Platzhalter statt eines
 * kaputten Bildsymbols.
 */
export function AuthImage({
  path,
  alt = '',
  className,
  style,
  fallback = null,
}: {
  path: string;
  alt?: string;
  className?: string;
  style?: CSSProperties;
  fallback?: ReactNode;
}) {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;

    setFailed(false);
    setUrl(null);

    fetchImageUrl(path)
      .then((result) => {
        if (cancelled) {
          // Zwischenzeitlich weggeblendet: Die eben erzeugte URL sofort
          // freigeben, sonst hält sie den Blob bis zum Neuladen der Seite.
          if (result) URL.revokeObjectURL(result);
          return;
        }
        if (!result) {
          setFailed(true);
          return;
        }
        objectUrl = result;
        setUrl(result);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  if (failed || !url) return <>{fallback}</>;
  return <img src={url} alt={alt} className={className} style={style} />;
}
